/* Vuex module: authentication (local Flask JWT via helpers/api). */
import { auth } from 'helpers/api'

const NS = 'auth'
const t = n => `${NS}/${n}`

export const getterTypes = {
  isLoggedIn: t('isLoggedIn'),
  currentUser: t('currentUser'),
  status: t('status'),
  error: t('error'),
  isAdmin: t('isAdmin'),
}

export const actionTypes = {
  login: t('login'),
  logout: t('logout'),
  restore: t('restore'),
}

const M = {
  SET_USER: 'SET_USER',
  SET_LOGGED_IN: 'SET_LOGGED_IN',
  SET_STATUS: 'SET_STATUS',
  SET_ERROR: 'SET_ERROR',
}

export default {
  namespaced: true,

  state: () => ({
    user: auth.currentUser(),
    loggedIn: auth.isLoggedIn(),
    status: 'idle', // idle | loading | complete | error
    error: null,
  }),

  getters: {
    isLoggedIn: s => s.loggedIn,
    currentUser: s => s.user,
    status: s => s.status,
    error: s => s.error,
    isAdmin: s => !!(s.user && s.user.role === 'admin'),
  },

  mutations: {
    [M.SET_USER](s, u) {
      s.user = u
    },
    [M.SET_LOGGED_IN](s, v) {
      s.loggedIn = v
    },
    [M.SET_STATUS](s, v) {
      s.status = v
    },
    [M.SET_ERROR](s, e) {
      s.error = e
    },
  },

  actions: {
    async login({ commit }, { email, password }) {
      commit(M.SET_STATUS, 'loading')
      commit(M.SET_ERROR, null)
      try {
        const user = await auth.signIn(email, password)
        commit(M.SET_USER, user)
        commit(M.SET_LOGGED_IN, true)
        commit(M.SET_STATUS, 'complete')
        return user
      } catch (err) {
        const msg =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          'Sign in failed.'
        commit(M.SET_ERROR, msg)
        commit(M.SET_STATUS, 'error')
        throw err
      }
    },

    async logout({ commit }) {
      await auth.signOut()
      commit(M.SET_USER, null)
      commit(M.SET_LOGGED_IN, false)
      commit(M.SET_STATUS, 'idle')
    },

    // Called on app boot to rehydrate/verify the session.
    async restore({ commit }) {
      commit(M.SET_STATUS, 'loading')
      try {
        const user = await auth.restore()
        commit(M.SET_USER, user)
        commit(M.SET_LOGGED_IN, !!user)
        commit(M.SET_STATUS, 'complete')
        return user
      } catch (err) {
        commit(M.SET_STATUS, 'error')
        throw err
      }
    },
  },
}
